import React, { useCallback, useContext } from 'react';

import { QButton } from '@qualio/ui-components';
import { useNavigate } from 'react-router-dom';

import { FeatureFlags } from '../../components/FeatureToggle/FeatureToggle.enum';
import { ProductContext } from '../../context/product';
import { DesignElementType } from '../../types/baseQualityItem';
import { EnabledFeatureFlag, FeatureToggle } from './FeatureFlag';

type Props = {
  type: string;
};

const SetupIntegrationButtonContent: React.FC<Props> = ({ type }) => {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate('../../self-service', { state: { type } });
  }, [navigate, type]);

  if (type === DesignElementType.RISK) {
    return null;
  }

  return (
    <FeatureToggle feature={FeatureFlags.SELF_SERVICE}>
      <EnabledFeatureFlag>
        <QButton variant="ghost" onClick={onClick} data-cy={`integration-${type}`}>
          Setup Integration
        </QButton>
      </EnabledFeatureFlag>
    </FeatureToggle>
  );
};

export const SetupIntegrationButton: React.FC<Props> = ({ type }) => {
  const product = useContext(ProductContext);

  if (!product) {
    return null;
  }

  return <SetupIntegrationButtonContent type={type} />;
};
